import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as appActions from "../../../core/app.store";
import * as config from '../../../common/config'

import tickIcon from "../../../assets/icon/tick.png";
import cancelIcon from "../../../assets/icon/cancel.png";

import headCellsListTask from './head-cell-list-task-need-help';
import DataTableSarang from '../../../components/datatable-sarang';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import viVN from "../../../language/vi-VN.json";
import { NotificationMessageType, getUserInfo } from "../../../utils/configuration";
import ShowNotification from "../../../components/react-notifications/react-notifications";

import * as taskCalendarManagementAction from "../../../redux/store-sarang/task-calendar/task-calendar-management.store";
import * as customerManagementAction from "../../../redux/store-sarang/customer/customer-management.store";
import * as herdsmanManagementAction from "../../../redux/store-sarang/herdsman/herdsman-management.store";

import ModalSubmitForm from '../../../components/sarang-modals/modal-submit-form/modal-submit-form';
import dayjs from 'dayjs';
import Select from "react-select";
import { optionsCuisineOrderStatus, optionsCustomerStatus, optionsReceiptTime } from '../../../common/constant';
import ModalConfirm from '../../../components/sarang-modals/modal-confirm/modal-confirm';
import FormAssignHerdman from '../add-edit-task/form-assign-herdsman';
import { UrlCollectionSarang } from '../../../common/url-collection-sarang';
import { Link, useHistory } from 'react-router-dom';
import styles from '../../custome-style.module.scss'
import { VIEW_MODE_PARAM } from '..';
import history from "../../../common/history";
import { useMediaQuery } from 'react-responsive';
import DataTablePagination from '../../../components/datatable-sarang/datatable-pagination';
import FormSearchWrapperSarang, { FormSearchFunctionButtons } from '../../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import MobileHeaderSarang from '../../../components/mobile-header/mobile-header-sarang';
import headCellsListTaskNeedHelp from './head-cell-list-task-need-help';

const configLocal = {
    defaultPageSize: config.Configs.DefaultPageSize,
    sortExpression: "datingTime desc",
    orderBy: "datingTime",
    order: "desc",
}

export default function CalendarNeedHelp(props) {

    const { register, handleSubmit, errors, setValue, control, getValues } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1024px)",
    });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1023px)" });

    const dispatch = useDispatch();
    const showLoading = (data) => dispatch(appActions.ShowLoading(data));
    const invisibleLinkRef = useRef(null);
    const [herdsmanId, setHerdsmanId] = useState(getUserInfo()?.herdsmanId);

    const [data, setData] = useState([])
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(configLocal.defaultPageSize);
    const [order, setOrder] = useState(configLocal.order);
    const [orderBy, setOrderBy] = useState(configLocal.orderBy);
    const [searchData, setSearchData] = useState();
    const [openSearch, setOpenSearch] = useState(false);

    const now = new Date();

    useEffect(() => {
        setValue("startDate", dayjs(now).format());
        setSearchData({ startDate: dayjs(now).format() });
        getListTaskManagement(1, configLocal.defaultPageSize, configLocal.sortExpression, { startDate: dayjs(now).format() });
        fetchData();
    }, []);

    const [herdsman, setHerdsman] = useState([]);
    const [customer, setCustomer] = useState([]);
    const getLookupHerdsman = async () => {
        try {
            const res = await herdsmanManagementAction.GetLookupHerdsman();
            if (res && res.content) {
                setHerdsman(res.content);
            }
        } catch (err) {
            throw err;
        }
    }

    const getLookupCustomer = async () => {
        try {
            const res = await customerManagementAction.GetLookupCustomer();
            if (res && res.content) {
                setCustomer(res.content);
            }
        } catch (err) {
            throw err;
        }
    }

    const fetchData = async () => {
        showLoading(true);
        try {
            await Promise.allSettled([
                getLookupHerdsman(),
                getLookupCustomer(),
            ]);
        } catch (err) {
            err && err.errorType &&
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
        } finally {
            showLoading(false);
        }
    }

    const getListTaskManagement = async (pageIndex = 1, pageSize = configLocal.defaultPageSize, sortExpression = configLocal.sortExpression, data=undefined) => {
        showLoading(true);
        try {
            const res = await taskCalendarManagementAction.GetListTaskNeedHelp(pageIndex, pageSize, sortExpression, data);
    
            if (res && res.content && res.content.items) {
                setData(res.content.items);
                setTotalItemCount(res.content.totalItemCount);
            }
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
            }
        } finally {
            showLoading(false);
        }
    };

    const handleSubmitAddEditTask = async (data) => {
        showLoading(true);

        try {
            let res = null;

            res = await taskCalendarManagementAction.AssignHerdsman(data);

            if (res && res.content) {
                let sortExpression = orderBy + ' ' + order;
                getListTaskManagement(page + 1, rowsPerPage, sortExpression, searchData);
            }
        } catch (err) {
            err && err.errorType &&
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
        } finally {
            showLoading(false);
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        let sort = isAsc ? 'desc' : 'asc';
        let sortExpression = property + ' ' + sort;
        getListTaskManagement(page + 1, rowsPerPage, sortExpression, searchData);
    };
    
    const handleChangePage = (newPage) => {
        setPage(newPage - 1);
        let sortExpression = orderBy + ' ' + order;
        getListTaskManagement(newPage, rowsPerPage, sortExpression, searchData);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        let sortExpression = orderBy + ' ' + order;
        getListTaskManagement(1, event.target.value, sortExpression, searchData);
    };
     
    const buttonOpenAddEditRef = useRef();
    const buttonOpenConfirmRef = useRef();
    const [isOpenAddEditDialog, setOpenAddEditDialog] = useState(false);
    const [isOpenDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isOpenActiveDialog, setOpenActiveDialog] = useState(false);
    const [isOpenDeactiveDialog, setOpenDeactiveDialog] = useState(false);
    const [isOpenChangeStatusDialog, setOpenChangeStatusDialog] = useState(false);
    const [isOpenChangeConfirmDialog, setOpenChangeConfirmDialog] = useState(false);
    const [isOpenHelpingToMeDialog, setOpenHelpingToMeDialog] = useState(false);

    const [selectedItem, setSelectedItem] = useState(null);
    const openAddDialog = () => {
        setOpenAddEditDialog(true);
        buttonOpenAddEditRef.current.click();
    };
    const openEditDialog = (item) => {
        setOpenAddEditDialog(true);
        setSelectedItem(item);
        buttonOpenAddEditRef.current.click();
    }
    const closeAddEditDialog = () => {
        setOpenAddEditDialog(false);
        setSelectedItem(null);
    }
    const openConfirmDialog = (item) => {
        setSelectedItem(item);
        buttonOpenConfirmRef.current.click();
    }
    const closeConfirmDialog = () => {
        setOpenDeleteDialog(false);
        setOpenActiveDialog(false);
        setOpenDeactiveDialog(false);
        setOpenChangeStatusDialog(false);
        setOpenChangeConfirmDialog(false);
        setOpenHelpingToMeDialog(false);
        //setSelectedItem(null);
    }
    
    const handleConfirm = async () => {
        try {
            showLoading(true);
            let res = null;
            if( isOpenDeleteDialog ) {
                res = await taskCalendarManagementAction.DeleteTask(selectedItem.id);
                if (res) {
                    getListTaskManagement();
                }
            } else if (isOpenActiveDialog) {
                // res = await taskCalendarManagementAction.ActiveCuisineOrder(selectedItem.id);
            } else if (isOpenDeactiveDialog) {
                // res = await taskCalendarManagementAction.DeActiveCuisineOrder(selectedItem.id);
            } else if (isOpenChangeStatusDialog) {
                // res = await taskCalendarManagementAction.ChangeCuisineOrderStatus({ id: selectedItem.id, status: selectedItem.orderStatusChange });
            } else if (isOpenChangeConfirmDialog) {
                // res = await taskCalendarManagementAction.ChangeConfirm({ id: selectedItem.id, herdsmanId: user.herdsmanId }); //selectedItem.herdsManConfirmId
            } else if (isOpenHelpingToMeDialog && herdsmanId) {
                res = await taskCalendarManagementAction.ReceiptHelping(selectedItem.id);
                if (res) {
                    setOpenAddEditDialog(true);
                    buttonOpenAddEditRef.current.click();
                }
            }

            

            showLoading(false);
            closeConfirmDialog();
        } catch (err) {
            showLoading(false);
            err && err.errorType &&
            ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
            );
        }
    }

    const onSubmit = (data) => {
        setSearchData(data);
        let sortExpression = orderBy + ' ' + order;
        setPage(0);
        getListTaskManagement(1, rowsPerPage, sortExpression, data);
        if (isTabletOrMobile)
            setOpenSearch(false);
    }

    const renderFormSearch = () => {
        return <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-md-6">
                    <label htmlFor="input-department-general">Swat</label>
                    <Select
                        isClearable
                        {...register("herdsmanId")}
                        placeholder="Swat"
                        onChange={(data) => setValue("herdsmanId", data ? data.value : null)}
                        options={herdsman.map(item => { return { label: item.name, value: item.id } })}
                        noOptionsMessage={() => "Không tồn tại"}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
                <div className="form-group col-md-6">
                    <label>Ta-lâng</label>
                    <Select
                        isClearable
                        {...register("customerId", {})}
                        placeholder="Chọn Ta-lâng"
                        closeMenuOnSelect={true}
                        onChange={(data) => setValue("customerId", data ? data.value : null)}
                        options={customer.map(item => { return { label: item.name, value: item.id } })}
                        noOptionsMessage={() => "Không có ta-lâng nào"}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4">
                    <label htmlFor="input-address" className="col-form-label">Địa chỉ</label>
                    <input id="input-address" name="address" placeholder="Địa chỉ" type="text" className="form-control" ref={register()} />
                </div>
                <div className="form-group col-md-8">
                    <label htmlFor="input-from-date">Ngày giờ</label>
                    <div className="row">
                        <div className="col-6">
                            <DatePicker
                                {...register("startDate")}
                                onChange={(data) => setValue("startDate", dayjs(data).format())}
                                defaultValue={dayjs(now)}
                                className="form-control"
                                format='DD/MM/YYYY'
                                slotProps={{ textField: { size: 'small' } }}
                            //label={"Nhập Ngày nhận"}
                            />
                        </div>
                        <div className="col-6">
                            <DatePicker
                                {...register("endDate")}
                                onChange={(data) => setValue("endDate", dayjs(data).format())}
                                className="form-control"
                                format='DD/MM/YYYY'
                                slotProps={{ textField: { size: 'small' } }}
                            //label={"Nhập Ngày nhận"}
                            />
                        </div>
                    </div>
                </div>

            </div>
            <div className="row">
                <div className="col-sm-12 pl-0">
                    <p className="text-center">
                        <button type="submit" className="btn btn-space btn-primary">Tìm kiếm</button>
                        <button className="btn btn-space btn-secondary">Xóa lọc</button>
                    </p>
                </div>
            </div>
        </form>
    }
    const renderListItemForMobile = () => {
        return <>
            <div className="accrodion-regular">
                <MobileHeaderSarang
                    headCell={headCellsListTaskNeedHelp}
                    handleSortChange={(sortExpression) => getListTaskManagement(page + 1, rowsPerPage, sortExpression, searchData)}
                    setOrder={setOrder}
                    setOrderBy={setOrderBy}
                />
                <div id="accordion">
                    {
                        /*
                        <div className="card">
                        <div className="d-flex align-items-center">
                            <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }}
                                data-toggle="collapse" aria-expanded="false" >
                                <div className="d-flex w-100">
                                    <label className='d-flex align-items-end justify-content-end' style={{ gap: "10px" }}>
                                        Xem
                                        <select
                                            className="custom-select custom-select-sm form-control form-control-sm"
                                            style={{ width: "50px" }}
                                            value={rowsPerPage}
                                            onChange={handleChangeRowsPerPage}
                                        >
                                            {config.Configs.DefaultPageSizeOption.map((pageSize, index) => (
                                                <option key={index} value={pageSize}>{pageSize}</option>
                                            ))}
                                        </select>
                                        mục
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                        */
                    }
                    {
                        data.length > 0 ?
                            data.map((item, index) => (
                                <div className="card" key={index}>
                                    <div className="d-flex align-items-center" id={`heading-${item.id}`}>
                                        <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }}
                                            data-toggle="collapse" data-target={`#collapse-${item.id}`} aria-expanded="false" aria-controls={`collapse-${item.id}`}>
                                            <div className="d-flex w-100 justify-content-between">
                                                <h5 className="mb-1">{dayjs(item.datingTime).format("DD/MM/YYYY HH:mm")} - {item.title} </h5>
                                            </div>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className='mt-2'><b>Ta-lâng: </b>
                                                        <span>
                                                            <b>{item.customerGender === "Nam" ? <li className="fas fa-male text-primary" title="Nam"></li> : <li className="fas fa-female text-secondary" title="Nữ"></li>}&nbsp;
                                                                {item.customerName}</b> ({item.customerYearOfBirth} - {item.customerDepartmentName})
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className="mt-0"><b>Nhận giúp đỡ: </b>&nbsp;
                                                        <span>
                                                            {
                                                                (item?.showReceiptButton) ?
                                                                    <span className={styles.assign_to_me} onClick={() => {
                                                                        setOpenHelpingToMeDialog(true);
                                                                        openConfirmDialog(item);
                                                                    }}>   Nhận giúp</span> : <></>
                                                            }
                                                            {item?.departmentHelpingName}
                                                        </span>
                                                    </div>
                                                    <div className="mt-0"><b>Ace giúp đỡ: </b>&nbsp;
                                                        <span>
                                                            {item.herdsmanHelpingName1} - {item.herdsmanHelpingName2}&nbsp;
                                                            {
                                                                item?.showAssignButton ?
                                                                    <i className="far fa-edit text-primary" onClick={() => { openEditDialog(item) }}></i> : <></>
                                                            }
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <i className="fas fa-angle-down p-2"></i>
                                    </div>
                                    <div id={`collapse-${item.id}`} className="collapse" aria-labelledby={`heading-${item.id}`} data-parent="#accordion">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className='mt-0'>
                                                        <b>Swat: </b>
                                                        <span>
                                                            {item.herdsmanName}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className='mt-0'><b>Địa điểm tiếp xúc: </b>
                                                        <span>{item.address}</span></div>
                                                </div>
                                            </div>

                                            <div className='mt-0'><b>Ghi chú:</b></div>
                                            <span>{item.description}</span>
                                        </div>
                                    </div>
                                </div>
                            )) : <div className="card">Chưa có dữ liệu</div>
                    }
                </div>
                {
                    totalItemCount > 0 ?
                        <DataTablePagination
                            totalItemCount={totalItemCount}
                            rowsPerPage={rowsPerPage}
                            pageIndex={page + 1}
                            handleChangePage={handleChangePage}
                        /> :
                        <></>
                }
            </div>
            <FormSearchWrapperSarang
                isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} openAddDialog={openAddDialog} hideNewButton={true }
            >
                {renderFormSearch()}
            </FormSearchWrapperSarang>
        </>
    }

    const renderTableForDesktop = () => {
        return <>
            <FormSearchWrapperSarang
                isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} openAddDialog={openAddDialog} hideNewButton={true}
            >
                {renderFormSearch()}
            </FormSearchWrapperSarang>
            <DataTableSarang
                // button functions
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                // head cells
                headCells={headCellsListTask}
                handleRequestSort={handleRequestSort}
                order={order}
                orderBy={orderBy}
                // pagination
                totalItemCount={totalItemCount}
                setRowsPerPage={setRowsPerPage}
                pageIndex={page}
                handleChangePage={handleChangePage}
            >
                <tbody>
                    {
                        data.length > 0 ?
                            data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td><span>{dayjs(row.datingTime).format("DD/MM/YYYY HH:mm")}</span></td>
                                    <td><span><b>{row.customerGender === "Nam" ? <li className="fas fa-male text-primary" title="Nam"></li> : <li className="fas fa-female text-secondary" title="Nữ"></li>}&nbsp;{row.customerName}</b> ({row.customerYearOfBirth})<br />Ban: <b>{row.customerDepartmentName}</b></span></td>
                                    <td>
                                        <span>
                                            {row.needHelp ? (
                                                <>
                                                    <img title="Cần trợ giúp"
                                                        src={tickIcon}
                                                        alt="Tick"
                                                    />
                                                    {
                                                        (row?.showReceiptButton) ?
                                                            <span className={styles.assign_to_me} onClick={() => {
                                                                setOpenHelpingToMeDialog(true);
                                                                openConfirmDialog(row);
                                                            }}>   Nhận</span> : <></>
                                                    }
                                                </>
                                            ) : (
                                                <img title=""
                                                    src={cancelIcon}
                                                    alt="Cancel"
                                                />
                                            )}
                                            {row?.departmentHelpingName}
                                        </span>
                                    </td>
                                    <td>{row.herdsmanHelpingName1} - {row.herdsmanHelpingName2}
                                        {
                                            row?.showAssignButton ?
                                                <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table edit" data-toggle="tooltip" data-placement="top"
                                                    title="Sửa"
                                                    onClick={() => { openEditDialog(row) }}
                                                >
                                                    <i className="far fa-edit"></i>
                                                </button> : <></>
                                        }
                                    </td>
                                    <td><span>{row.herdsmanName}</span></td>
                                    <td><span>{row.address}</span></td>
                                    <td><span>{row.title}</span></td>
                                    <td><span>{row.contentHelping}</span></td>
                                    <td><span>{row.description}</span></td>
                                </tr>
                            )) :
                            <tr><td colSpan={10}>Chưa có dữ liệu</td></tr>
                    }
                </tbody>
            </DataTableSarang>
        </>
    }
    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                {
                    isDesktopOrLaptop ? renderTableForDesktop() : <></>
                }

                {
                    isTabletOrMobile ? renderListItemForMobile() : <></>
                }
            </div>
            <button ref={buttonOpenAddEditRef} type="button" className="d-none" data-toggle="modal" data-target="#modalSubmitForm">
                Launch modal add edit
            </button>
            <button ref={buttonOpenConfirmRef} type="button" className="d-none" data-toggle="modal" data-target="#modalConfirm">
                Launch modal confirm
            </button>

            <ModalSubmitForm
                title={!selectedItem ? "Gán Ace trợ giúp" : "Chỉnh sửa Ace trợ giúp"}
                open={isOpenAddEditDialog}
                onClose={closeAddEditDialog}
            >
                <FormAssignHerdman
                    customer={customer}
                    herdsman={herdsman}
                    // ===
                    updateItem={selectedItem}
                    handleSubmitAddEditTask={(data) => handleSubmitAddEditTask(data)}
                />
            </ModalSubmitForm>

            <ModalConfirm
                title={"Xác nhận"}
                prompt={
                    isOpenDeleteDialog ? "Ae/Ce có chắc chắn muốn xóa không?":
                    isOpenActiveDialog ? "Ae/Ce có chắc chắn muốn xác nhận không?":
                    isOpenDeactiveDialog ? "Ae/Ce có chắc chắn muốn hủy xác nhận không?": 
                    isOpenChangeStatusDialog ? `Ae/Ce có chắc chắn muốn thay đổi trạng thái thành <b>"${selectedItem?.orderStatusNameChange}"</b>?`:
                    isOpenChangeConfirmDialog ? `Ae/Ce có chắc chắn muốn bản ghi đăng ký suất này ăn được xác nhận bởi a/c/e <b>"${selectedItem?.herdsManConfirmName}"</b>?` :
                    isOpenHelpingToMeDialog ? `Ae/Ce có chắc chắn muốn hỗ trợ chia sẻ cho trường hợp này?"</b>?` : ""
                }
                open={isOpenDeleteDialog ||
                    isOpenActiveDialog ||
                    isOpenDeactiveDialog  ||
                    isOpenChangeStatusDialog ||
                    isOpenChangeConfirmDialog ||
                    isOpenHelpingToMeDialog
                }
                onClose={closeConfirmDialog}
                onConfirm={handleConfirm}
            />
        </div>
    )
}